import { createPortal } from 'react-dom';

export default function FlowSheetModal({ title, open, onClose, children }) {
  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[120] flex items-end justify-center bg-black/50"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-t-[16px] bg-white px-4 pb-[calc(1.25rem+env(safe-area-inset-bottom))] pt-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-base font-bold text-gray-900">{title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="text-sm font-semibold text-primary"
          >
            Cancel
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
}

function FormField({ label, children }) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-semibold text-gray-600">{label}</span>
      {children}
    </label>
  );
}

const inputClass =
  'w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:border-primary focus:outline-none';

const volumeInputClass =
  'w-full rounded-lg border border-gray-200 px-3 py-3 text-2xl font-semibold focus:border-primary focus:outline-none';

export function FlowSheetFormField({ label, ...props }) {
  return (
    <FormField label={label}>
      <input className={inputClass} {...props} />
    </FormField>
  );
}

export function FlowSheetVolumeField({ label, inputRef, ...props }) {
  return (
    <FormField label={label}>
      <input
        ref={inputRef}
        className={volumeInputClass}
        type="number"
        inputMode="decimal"
        {...props}
      />
    </FormField>
  );
}

export function FlowSheetSelectField({ label, value, onChange, options, optionLabels }) {
  return (
    <FormField label={label}>
      <select value={value} onChange={onChange} className={inputClass}>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {optionLabels?.[opt]?.label || opt}
          </option>
        ))}
      </select>
    </FormField>
  );
}

export function FlowSheetSubmitButton({ onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="mt-4 w-full rounded-xl bg-primary py-3 text-sm font-semibold text-white"
    >
      {children}
    </button>
  );
}

export function FlowSheetOutlineButton({ onClick, children }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="rounded-lg border border-primary px-3 py-1.5 text-xs font-semibold text-primary"
    >
      {children}
    </button>
  );
}

export { inputClass };
